module.exports = __webpack_public_path__ + "static/media/14pulgadas.60fe5bb0.jpg";